import { render } from "./PetsDetails.vue?vue&type=template&id=fe43282e"
import script from "./PetsDetails.vue?vue&type=script&lang=js"
export * from "./PetsDetails.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__